export default __webpack_public_path__ + "static/media/e-met-picturemark-l.df22119d.svg";